export default __webpack_public_path__ + "static/media/user.38e8e206.png";